import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";
import {$agentFactory} from "../../$agent.factory";

export class AgentsRadioTableCtrl implements IController {

  active: any;
  selectedId?: string;
  skills?: string[];
  sessionRecording: any;
  isRegistrationStatusActive: boolean;
  status: any;
  queryString: any;
  team: any;
  teamIds?: string[];
  branchIds: any;
  serviceAreaIds: any;
  tags: any;
  noArea: boolean;
  noBranches: boolean;
  agentTypes: any;
  agentSkills: string[];
  depotIds: any;
  enableActions: any;
  enableSelection: any;
  selectedIds: any;
  accountId: any;
  gpsStatus: boolean;
  gpsPermissions: string[];
  doReload: any;
  onReload: Function;
  onAgentSelect: Function;

  public isScrollable: boolean;
  private loadLimit: number;
  private agentsRef: any;
  private infiniteScroll: any;
  private expendedAgentId: string;
  private selectedKeys: any;
  public siteTimeZone: string;
  public selectedAgentId: string;

  constructor(private $log, private $agents: $agentsFactory, private $infiniteScroll, private $mdMedia, private splitService, private $agent: $agentFactory) {
  }

  $onInit() {
    this.loadLimit = 50;
    this.agentsRef = this.$agents();

    this.agentsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});

    // Ensure no duplicates occur if manual fetch collides with pagination queries
    this.infiniteScroll.itemsChangeHandler((items) => {
      const uniqueItems = _.uniqBy(items, 'id');
      if (uniqueItems.length !== items.length) {
        this.infiniteScroll._items = uniqueItems;
        this.infiniteScroll._length = uniqueItems.length;
      }
    });

    this.siteTimeZone = this.splitService.getTimeZone();

    if (this.selectedId) {
      this.$agent(this.selectedId).$asyncValue()
        .then((agent) => {
          if (agent) {
            this.infiniteScroll.removeItems([{id: agent.id}]); // Remove if already exists to ensure it moves to the top
            this.infiniteScroll.addItems([agent]); // Push to the top
          }
        })
        .catch((error) => this.$log.error('Failed to load selected agent', error));
    }
  }
  $onChanges(changes) {
    if (
      (changes.status && !changes.status.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.noBranches && !changes.noBranches.isFirstChange()) ||
      (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.noArea && !changes.noArea.isFirstChange()) ||
      (changes.agentTypes && !changes.agentTypes.isFirstChange()) ||
      (changes.depotIds && !changes.depotIds.isFirstChange()) ||
      (changes.active && !changes.active.isFirstChange()) ||
      (changes.sessionRecording && !changes.sessionRecording.isFirstChange()) ||
      (changes.isRegistrationStatusActive && !changes.isRegistrationStatusActive.isFirstChange()) ||
      (changes.team && !changes.team.isFirstChange()) ||
      (changes.teamIds && !changes.teamIds.isFirstChange()) ||
      (changes.gpsStatus && !changes.gpsStatus.isFirstChange()) ||
      (changes.gpsPermissions && !changes.gpsPermissions.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange())

    ) {
      this._query();
    }

    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._query();
      }
    }

  };

  setEvents() {
    const div1 = document.getElementById('header');
    const container = document.getElementById('vertical-container');
    const div2 = container ? container.querySelector('.md-virtual-repeat-scroller') : null;

    if (div1 && div2) {
      div2.addEventListener('scroll', e => {
        div1.scrollTop = div2.scrollTop;
        div1.scrollLeft = div2.scrollLeft;
      }, {passive: true})
    }

    // Force recalculation of md-virtual-repeat size
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  private _getQueryPayload() {
    return {
      accountIds: this.accountId,
      branchIds: this.branchIds,
      noBranches: this.noBranches,
      areaIds: this.serviceAreaIds,
      noArea: this.noArea,
      agentTypes: this.agentTypes,
      skill: this.skills,
      depotIds: this.depotIds,
      status: this.status,
      query: this.queryString,
      limit: this.loadLimit,
      active: this.active,
      sessionRecording: this.sessionRecording,
      tags: this.tags,
      gpsStatus: this.gpsStatus,
      gpsPermission: this.gpsPermissions,
      registrationStatusActive: this.isRegistrationStatusActive,
      teamIds: this.teamIds?.length ? this.teamIds : _.get(this.team, 'id')
    };
  }

  private _query() {
    this.agentsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsRadioTable', {
    bindings: {
      active: '<?',
      selectedId: '<?',
      skills: '<',
      teamIds: '<?',
      branchIds: '<?',
      serviceAreaIds: '<?',
      tags: '<?',
      noArea: '<?',
      noBranches: '<?',
      agentTypes: '<?',
      depotIds: '<?',
      enableActions: '<?',
      enableSelection: '<?',
      selectedIds: '<?',
      accountId: '<',
      gpsStatus: '<?',
      queryString: '<?',
      gpsPermissions: '<?',
      agentIds: '<?',
      doReload: '<',
      onReload: '&',
      onAgentSelect: '&',
    },
    template: require('./agents-radio-table.html').default,
    controller: AgentsRadioTableCtrl
  });
